'use es6';

import get from 'transmute/get';
import getIn from 'transmute/getIn';
export const getDisablePrefill = get('disablePrefill');
export const getStagedPrefillEmail = state => getIn(['stagedFormState', 'email'], state) || '';
export const getInitialPrefillEmail = state => getIn(['initialFormState', 'email'], state) || '';